import React from 'react';
import PropTypes from 'prop-types';

import { Autocomplete, TextField } from '@mui/material';

const propTypes = {
  options: PropTypes.array.isRequired, // [{ label, value }], same shape a Select takes
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired, // called (value, id), like AppSelect, so handlers port over
  id: PropTypes.string,

  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
}

const defaultProps = {
  value: '',
  id: undefined,
  label: '',
  placeholder: 'Escribí para buscar',
  disabled: false,
  error: undefined,
}

// A Select you can type into, for lists long enough that scanning them with the mouse is the slow
// part - couriers, teams. MUI's Autocomplete does the filtering; the shared Autocomplete in this
// folder is the other case, where the list lives on the server.
//
// Keep using AppSelect for short lists: with four options, typing is slower than picking.
const SearchableSelect = (props) => {
  const { options, value, onChange, id, label, placeholder, disabled, error } = props;

  // Compared as strings because several callers hold numeric ids against string options.
  const selected = options.find((option) => String(option.value) === String(value)) ?? null;

  return (
    <Autocomplete
      id={id}
      options={options}
      value={selected}
      disabled={disabled}
      fullWidth
      getOptionLabel={(option) => option.label ?? ''}
      isOptionEqualToValue={(option, chosen) => String(option.value) === String(chosen.value)}
      onChange={(_event, option) => onChange(option ? option.value : '', id)}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={placeholder}
          InputLabelProps={{ shrink: true }}
          error={!!error}
          helperText={typeof error === 'string' ? error : undefined}
        />
      )}
    />
  );
};

SearchableSelect.propTypes = propTypes;
SearchableSelect.defaultProps = defaultProps;

export default SearchableSelect;
